export default function LoadingSkeleton() {
  return (
    <div data-testid="loading-skeleton" className="flex flex-col h-screen w-screen bg-zinc-900">
      {/* Toolbar placeholder */}
      <div
        data-testid="toolbar-placeholder"
        className="h-12 bg-zinc-800 animate-pulse flex items-center gap-2 px-4"
      >
        <div className="h-6 w-24 bg-zinc-700 rounded" />
        <div className="h-6 w-16 bg-zinc-700 rounded" />
        <div className="h-6 w-16 bg-zinc-700 rounded" />
        <div className="h-6 w-20 bg-zinc-700 rounded" />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Canvas placeholder */}
        <div
          data-testid="canvas-placeholder"
          className="flex-1 bg-zinc-850 animate-pulse flex items-center justify-center"
          style={{ backgroundColor: '#1a1a2e' }}
        >
          <div className="w-3/4 h-3/4 bg-zinc-800 rounded-lg" />
        </div>

        {/* Sidebar placeholder */}
        <div
          data-testid="sidebar-placeholder"
          className="w-80 bg-zinc-800 animate-pulse flex flex-col gap-3 p-4"
        >
          <div className="h-8 bg-zinc-700 rounded w-full" />
          <div className="h-6 bg-zinc-700 rounded w-3/4" />
          <div className="h-6 bg-zinc-700 rounded w-1/2" />
          <div className="h-32 bg-zinc-700 rounded w-full" />
          <div className="h-6 bg-zinc-700 rounded w-2/3" />
          <div className="h-6 bg-zinc-700 rounded w-full" />
        </div>
      </div>
    </div>
  );
}
